import React, { useContext } from "react";
import styled from "styled-components";
import Logging from "../Logging";
import ActionsContext from "common/ActionsContext";
import { Header } from "common/Header";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        onClick={() => actions.send("do-load")}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">refresh</i>
      </a>
    </ul>
  );
};

const SystemLogs = ({returnView}) => (
  <div id="viewLogsSystem" className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div className="card">
      <Header title="System logs" contextMenu={<ContextMenu />} returnUrl={returnView} backButton={!!returnView}/>
      <div className="body flex-panel-column">
        <Logging name="system" />
      </div>
    </div>
  </div>
);

export default SystemLogs;
